import axios from "axios";
import { AUTH } from "src/auth/FirebaseContext";

export const url = "https://star-api.herokuapp.com/";
// export const url = "http://localhost:8080";
//"http://localhost:8080"   https://star-api.herokuapp.com/
const TestApi = axios.create({
  baseURL: `${url}`,
  headers: { "content-type": "application/json" },
});

TestApi.interceptors.request.use(async (config) => {
  // const token = window.localStorage.getItem("accessToken");
  // config.headers.authorization = token;
  if (!AUTH.currentUser) return config;
  const token = await AUTH.currentUser.getIdToken();
  config.headers.Authorization = `${token}`;
  return config;
});

export default TestApi;
